module.exports = __webpack_public_path__ + "assets/f7835c5496f160944d4c0c17d64e55cd.png";